import {
    BLACK,
    BLUE_700,
    ORANGE_200,
    RED_500,
    RED_800,
    WHITE,
} from '../../styles/colors';

interface BackgroundColorOption {
    value: string;
    label: string;
    backgroundColor: string;
    titleColor: string;
    subtitleColor: string;
    buttonColor: string;
}

export const BACKGROUND_COLORS: BackgroundColorOption[] = [
    {
        value: RED_800,
        label: 'Red',
        backgroundColor: RED_800,
        titleColor: WHITE,
        subtitleColor: WHITE,
        buttonColor: RED_500,
    },
    {
        value: BLUE_700,
        label: 'Blue',
        backgroundColor: BLUE_700,
        titleColor: WHITE,
        subtitleColor: WHITE,
        buttonColor: RED_500,
    },
    {
        value: ORANGE_200,
        label: 'Yellow',
        backgroundColor: ORANGE_200,
        titleColor: BLACK,
        subtitleColor: BLACK,
        buttonColor: RED_500,
    },
];
